interface SVGProps {
    size?: number;
}


export const Plus = ({ size }: SVGProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size ? size : '10'} height={size ? size : '10'} viewBox={`0 0 ${size ? size : '10'} ${size ? size : '10'}`} fill="none">
            <line x1="0%" x2="100%" y1="50%" y2="50%" strokeWidth="2" stroke="#838280" />
            <line x1="50%" x2="50%" y1="0%" y2="100%" strokeWidth="2" stroke="#838280" />
        </svg>
    )
}